import React from 'react'
import { Alert, InlineButton, useOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useNamesExperienceToggle } from '../../../../hooks/useNamesExperienceOptIn'
import TurnOffNamesExperienceDialog from './TurnOffNamesExperienceDialog'

/**
 * Banner shown when the user is opted into the updated Names experience, offering a control to turn
 * it off (which opens the turn-off confirmation dialog).
 *
 * @returns {JSX.Element}
 */
export default function OptedInBanner() {
  const [t] = useTranslation()
  const { turnOff } = useNamesExperienceToggle()
  const turnOffOverlay = useOverlay()

  return (
    <>
      <Alert outlined type="help" dense>
        {t('namesExperienceBanner.optedIn.description', "You're using the updated look for viewing and editing names.")}{' '}
        <InlineButton onClick={turnOffOverlay.handleClick} linkName="names-experience-banner-turn-off">
          {t('namesExperienceBanner.optedIn.turnOff', 'Turn off the updated look')}
        </InlineButton>
      </Alert>
      <TurnOffNamesExperienceDialog overlay={turnOffOverlay} onTurnOff={turnOff} />
    </>
  )
}
